import { useRouter } from "next/router";
import { getBrandOverviewLocalizedPath } from "@/common/utils/brands.utils";

export const useBrandOverviewLocalizedPath = () => {
  const { locale } = useRouter();
  return { path: getBrandOverviewLocalizedPath(locale) };
};
